import fetch from '@/utils/fetch'

/**查询班级列表*/
export function getListClasses(query) {
    return fetch({
      url: '/teacher/listClasses',
      method: 'get',
      params: query
    });
}

/**获取分组人员名单*/
export function getListGroupStudent(query) {
    return fetch({
      url: '/class/listGroupStudent',
      method: 'get',
      params: query
    });
}

/**保存分组名单*/
export function saveGroup (param) {
  param = JSON.stringify(param)
  return fetch({
    url: '/class/saveGroup',
    method: 'post',
    data: param
  })
}

/**夸克监控数据*/
export function listStudentByClassId (params) {
  return fetch({
    url: '/kuake/listStudentByClassId',
    method: 'get',
    params
  })
}

// AIPT靶向班
/**根据学届获取全日制班级列表*/
export function getFulltimeClassByPeriodCode (params) {
  return fetch({
    url: '/teacher/getFulltimeClassByPeriodCode',
    method: 'get',
    params
  })
}

/**根据学届获取靶向班列表*/
export function getTargetingClassByPeriodCode (params) {
  return fetch({
    url: '/teacher/getTargetingClassByPeriodCode',
    method: 'get',
    params
  })
}
/**根据全日制班级id获取全日制班级学生*/
export function getFulltimeClassStudent (params) {
  return fetch({
    url: '/targeting/class/getFulltimeClassStudent',
    method: 'get',
    params
  })
}
/**根据靶向班id获取靶向班详情*/
export function getDetail (params) {
  return fetch({
    url: '/targeting/class/getDetail',
    method: 'get',
    params
  })
}
/**根据学届获取班级以及科目*/
export function getClassAndSubjectByPeriodCode (params) {
  return fetch({
    url: '/teacher/getClassAndSubjectByPeriodCode',
    method: 'get',
    params
  })
}
/**根据靶向班id删除靶向班*/
export function deleteTargetClass (params) {
  return fetch({
    url: '/targeting/class/delete',
    method: 'get',
    params
  })
}

/**保存靶向班信息*/
export function saveTargetClass (params) {
  params = JSON.stringify(params)
  return fetch({
    url: '/targeting/class/save',
    method: 'post',
    data: params
  })
}

/** 获取夸克临时地址 */
export function getKuakeLoginUrl (params) {
  return fetch({
    url: '/kuake/getKuakeLoginUrl',
    method: 'get',
    params
  })
}

